// Nome di una task da mostrare. Le task create nei servizi (chiavi tsk_…)
// portano il nome con sé in task_label; le storiche usano la mappa di
// etichette della pagina, che resta il riferimento per il loro testo.
export function etichettaTask(task, etichette = {}) {
  if (!task) return "";
  return task.task_label || etichette[task.task_type] || task.task_type || "";
}
